import React from "react";
import { Link } from "react-router-dom";
import { MENU_SECTION_IMAGES } from "../data/assets";
import { useI18n } from "../data/i18n";
import Reveal from "../components/Reveal";

// Keep the lunch menu available in the codebase while it is hidden from navigation.
const SHOW_LUNCH_MENU = true;

const DiamondDivider = () => (
  <div className="flex items-center justify-center gap-2 my-4">
    <div className="w-12 h-px bg-gradient-to-r from-transparent to-[#e4c590]"></div>
    <span className="diamond-mark"></span>
    <span className="diamond-mark opacity-60"></span>
    <span className="diamond-mark"></span>
    <div className="w-12 h-px bg-gradient-to-l from-transparent to-[#e4c590]"></div>
  </div>
);

const MenuPage = () => {
  const { t } = useI18n();
  const sections = [
    ...(SHOW_LUNCH_MENU ? [{ title: t("menu.lunch"), subtitle: t("menu.lunch_hours"), desc: t("menu.lunch_desc"), image: MENU_SECTION_IMAGES.LUNCH, link: "/menu/lunch" }] : []),
    { title: t("menu.main"), desc: t("menu.main_desc"), image: MENU_SECTION_IMAGES.MAIN, link: "/menu/items" },
    { title: t("menu.drinks"), desc: t("menu.drinks_desc"), image: MENU_SECTION_IMAGES.DRINKS, link: "/menu/drinks" },
    { title: t("menu.alcohol"), desc: t("menu.alcohol_desc"), image: MENU_SECTION_IMAGES.ALCOHOL, link: "/menu/alcohol" },
  ];

  return (
    <div className="bg-[#0a0a0a] pt-32 pb-24 min-h-screen relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 relative">
        <Reveal direction="up">
          <div className="text-center mb-16">
            <p className="section-label">{t("menu.label")}</p>
            <h1 className="display text-5xl md:text-7xl text-[#f5f0e6] mt-3">{t("menu.title")}</h1>
            <DiamondDivider />
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {sections.map((section, idx) => (
            <Reveal key={idx} direction={idx % 2 === 0 ? "left" : "right"} delay={idx * 100}>
              <Link 
                to={section.link} 
                className="block bg-[#0f0f0f] border border-[#1f1f1f] overflow-hidden hover:border-[#e4c590]/60 transition-colors duration-500 group h-full flex flex-col hover:bg-[#141414] cursor-pointer"
              >
                {section.image && (
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={section.image}
                      alt={section.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                )}
                <div className="p-8 lg:p-10 text-center flex-1 flex flex-col">
                  {section.subtitle && (
                    <p className="text-[#e4c590] uppercase tracking-widest text-xs mb-2">{section.subtitle}</p>
                  )}
                  <h2 className="display text-3xl md:text-4xl text-[#f5f0e6] mb-4">{section.title}</h2>
                  <DiamondDivider />
                  <p className="text-[#a8a297] leading-relaxed mb-8 text-sm flex-1">{section.desc}</p>
                  <span className="cb-btn cb-btn-outline inline-block self-center pointer-events-none">
                    <span className="cb-btn-text cb-btn-text-1">{t("menu.see_menu")}</span>
                    <span className="cb-btn-text cb-btn-text-2" aria-hidden="true">{t("menu.see_menu")}</span>
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuPage;